// extracted by mini-css-extract-plugin
module.exports = {"secondFold":"secondFold_secondFold__sFo_T","heading":"secondFold_heading__Vcha1","subParagraph":"secondFold_subParagraph__m_r06","mainDiv":"secondFold_mainDiv__TNN3N"};